import dayjs from "dayjs";
import { SourceFilesListProps } from "./SourceFilesList";
import { formatBytes } from "../../../../../../../../utilities/helpers";
import { COMBINED_FILE_SIZE_LIMIT, getCombinedFileSize } from "../../SourceSelectionPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";
import { OverlayTrigger, OverlayTriggerProps, Popover } from "react-bootstrap";

export default function SourceFilesListSummary(props: SourceFilesListProps) {
    const combinedFileSize = getCombinedFileSize(props.sourceFiles);
    const overLimit = combinedFileSize - COMBINED_FILE_SIZE_LIMIT;
    const isWithinLimit = overLimit <= 0;

    const count = props.sourceFiles.length;
    const size = formatBytes(combinedFileSize);
    const duration = dayjs.duration(props.sourceFiles.reduce((acc, f) => acc + (f.duration ?? 0), 0)).humanize();

    const overlayProps = { placement: "bottom", delay: { show: 250, hide: 350 } } as OverlayTriggerProps;

    return (
        <div>
            <div className="gap-4 d-flex justify-content-center">
                <OverlayTrigger
                    {...overlayProps}
                    overlay={
                        <Popover>
                            <Popover.Body>Number of files</Popover.Body>
                        </Popover>
                    }
                >
                    <span>
                        <strong>File count:</strong> {count}
                    </span>
                </OverlayTrigger>

                <OverlayTrigger
                    {...overlayProps}
                    overlay={
                        <Popover>
                            <Popover.Body className={isWithinLimit ? "" : "text-danger"}>
                                {isWithinLimit
                                    ? "Combined size of all files"
                                    : `The combined size of the files exceeds the limit of ${formatBytes(
                                          COMBINED_FILE_SIZE_LIMIT,
                                      )}. Please remove at least ${formatBytes(
                                          overLimit,
                                      )} worth of files from the list.`}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <span className={`${isWithinLimit ? "" : "text-danger"}`}>
                        <strong>Total size: </strong>
                        <span>
                            {size} {!isWithinLimit && <FontAwesomeIcon icon={faExclamationCircle} />}
                        </span>
                    </span>
                </OverlayTrigger>

                <OverlayTrigger
                    {...overlayProps}
                    overlay={
                        <Popover>
                            <Popover.Body>Combined duration of all files</Popover.Body>
                        </Popover>
                    }
                >
                    <span>
                        <strong>Total duration:</strong> {duration}
                    </span>
                </OverlayTrigger>
            </div>
        </div>
    );
}
